import Vue from 'vue';

// Lib imports
import axios from 'axios';

let apiClient = axios.create({
  baseURL: process.env.VUE_APP_APIURL + '/api',
  withCredentials: true, // required to handle the CSRF token
});

Vue.prototype.$http = apiClient;
